import { Component, createRef } from "react";
import { IBaseComponentProps, NSBoxString } from "namirasoft-site-react";

export interface ResourceLineProps extends IBaseComponentProps
{
	index: number;
	deletable: boolean;
	onDelete: () => void;
	onChanged?: (value: string) => void;
}

export default class ResourceLine extends Component<ResourceLineProps>
{
	static isEmpty(value: string | null): boolean
	{
		if (value)
			return false;
		return true;
	}

	private NSBoxString_Resource = createRef<NSBoxString>();

	constructor(props: ResourceLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError?: boolean)
	{
		let resource = this.NSBoxString_Resource.current?.getValue(checkError) ?? "";
		return resource;
	}

	setValue(value: string)
	{
		this.NSBoxString_Resource.current?.setValue(value)
	}

	isDirty(): boolean
	{
		return ResourceLine.isEmpty(this.getValue());
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue());
	}

	override render()
	{
		return (
			<NSBoxString
				ref={this.NSBoxString_Resource}
				{...this.props}
				title={`Resource ${this.props.index + 1}`}
				required={false}
				onChanged={this.onChanged}
				style={{ ...this.props.style, width: "100%" }}
				menu={{
					builtin: {
						delete: {
							enabled: this.props.deletable,
							onDelete: () => { this.props.onDelete(); }
						}
					},
					items: []
				}}
			/>
		);
	}
}